import React from 'react';
import {Grid, Typography} from "@mui/material";
import CountrySelector from "../selector/CountrySelector";
import {CustomerDto} from "../../model/customer/Customer";
import {InvoiceParty} from "../../model/invoice/pdf/PdfInvoice";
import {Trans} from "react-i18next";

type IProps = {
    party: CustomerDto | InvoiceParty,
    type: "from" | "to"
}

export const PartyComponent = ({party, type}: IProps) => {
    const address = [party.address, party.city, party.postalCode, CountrySelector.findByCode(party.countryCode)?.name].filter(Boolean)
    const invoicePartyText = `Invoice ${type}`
    return <>
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Typography variant="subtitle2">
                    <i><Trans i18nKey={`single_invoice.party.${invoicePartyText}`}>{invoicePartyText}</Trans></i>
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant={"h6"}>
                    {party.name + (party.regNumber ? ` (${party.regNumber})` : "")}
                </Typography>
            </Grid>
            {party.vatNumber && (
                    <Grid item xs={12}>
                        <Typography variant={"subtitle1"}>
                            VAT: {party.vatNumber}
                        </Typography>
                    </Grid>
            )}
            {
                    address.length > 0 && <Grid item xs={12}>
                        <Typography variant={"subtitle1"}>
                            {address.join(", ")}
                        </Typography>
                    </Grid>
            }
            {
                    party.email && <Grid item xs={12}>
                        <Typography variant={"subtitle1"}>
                            {party.email}
                        </Typography>
                    </Grid>
            }
            {
                    party.phoneNo && <Grid item xs={12}>
                        <Typography variant={"subtitle1"}>
                            {party.phoneNo}
                        </Typography>
                    </Grid>
            }
        </Grid>
    </>
}
